import type { FC } from 'react';

import { type IBaseButtonProps } from './BaseButton'
import { SecondaryButtonStyled } from './styles/SecondaryButtonStyled'

export const SecondaryButton: FC<IBaseButtonProps> = SecondaryButtonStyled

SecondaryButton.displayName = 'SecondaryButton'
